import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-add-city',
  templateUrl: './add-city.component.html',
  styleUrls: ['./add-city.component.scss']
})
export class AddCityComponent {

  
  public loading:boolean = false;
  public submitted:boolean = false;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public CurrentDetail:any=[];
  public CurrentUrl:any=this.router.url;
  public statusCheck : any = 1 ;


  masterData = new FormGroup({
    name:new FormControl('',Validators.compose([
      Validators.required ])), 
  })
  
   get f() { return this.masterData.controls; }

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) {

  }

  ngOnInit(): void {
  }


  Onsubmit(){
    this.submitted = true;    
      let userdetail:any = this.masterData;      
       var url:any='master/add-city';
       var detail:any={
        "countryId":localStorage.getItem('hva_cid'),
         "name":userdetail.value.name
       };
       if(userdetail.valid){  
        this.loading=true;     
          this.service.PostApis(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){         
              this.masterData.reset();
              this.submitted = false;  
              this.loading=false;  
              this.service.back();
            } else {
              this.service.dangerAlert(response.message);
              this.loading=false;
            }
          }), (error:any) => {
            this.loading=false;
          });
       }
  // }     
    
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
}
